import React from 'react';
import TemplateDashboardTabsHeader from './TemplateDashboardTabsHeader';
import TemplateDashboardViewport from './TemplateDashboardViewport';

const TemplateDashboardTabPanel = ({
    dashboardPanelRef,
    dashboardViewportRef,
    t,
    details,
    edit,
    userRole,
    currentDashboard,
    setCurrentDashboard,
    setSearchParams,
    setDetails,
    editingTabRoleData,
    setEditingTabRoleData,
    editTriggerRef,
    setEditPopupAnchor,
    addTriggerRef,
    setAddPopupAnchor,
    setAddDashboard,
    canReorderDashboardTabs,
    isDashboardExpandedActive,
    webDashboardT,
    isMultiSelectEnabled,
    handleMultiSelectDashboardToggle,
    isMultiSelectToggleReady,
    isCurrentDashboardFixedWidth,
    handleFixedWidthDashboardToggle,
    isFixedWidthToggleReady,
    setIsDashboardExpanded,
    dashboardExpandLabel,
    dashboardMaxHeight,
    handleFixedWidthStateChange,
    registerFixedWidthToggleHandler,
    handleMultiSelectStateChange,
    registerMultiSelectToggleHandler,
}) => (
    <div
        ref={dashboardPanelRef}
        className={`td-dashboard-panel${isDashboardExpandedActive ? ' dashboard-edit-expanded-panel' : ''}`}
    >
        <TemplateDashboardTabsHeader
            t={t}
            details={details}
            edit={edit}
            userRole={userRole}
            currentDashboard={currentDashboard}
            setCurrentDashboard={setCurrentDashboard}
            setSearchParams={setSearchParams}
            setDetails={setDetails}
            editingTabRoleData={editingTabRoleData}
            setEditingTabRoleData={setEditingTabRoleData}
            editTriggerRef={editTriggerRef}
            setEditPopupAnchor={setEditPopupAnchor}
            addTriggerRef={addTriggerRef}
            setAddPopupAnchor={setAddPopupAnchor}
            setAddDashboard={setAddDashboard}
            canReorderDashboardTabs={canReorderDashboardTabs}
            isDashboardExpandedActive={isDashboardExpandedActive}
            webDashboardT={webDashboardT}
            isMultiSelectEnabled={isMultiSelectEnabled}
            handleMultiSelectDashboardToggle={handleMultiSelectDashboardToggle}
            isMultiSelectToggleReady={isMultiSelectToggleReady}
            isCurrentDashboardFixedWidth={isCurrentDashboardFixedWidth}
            handleFixedWidthDashboardToggle={handleFixedWidthDashboardToggle}
            isFixedWidthToggleReady={isFixedWidthToggleReady}
            setIsDashboardExpanded={setIsDashboardExpanded}
            dashboardExpandLabel={dashboardExpandLabel}
        />
        <TemplateDashboardViewport
            dashboardViewportRef={dashboardViewportRef}
            edit={edit}
            details={details}
            setDetails={setDetails}
            currentDashboard={currentDashboard}
            dashboardMaxHeight={dashboardMaxHeight}
            handleFixedWidthStateChange={handleFixedWidthStateChange}
            registerFixedWidthToggleHandler={registerFixedWidthToggleHandler}
            handleMultiSelectStateChange={handleMultiSelectStateChange}
            registerMultiSelectToggleHandler={registerMultiSelectToggleHandler}
        />
    </div>
);

export default TemplateDashboardTabPanel;
